import RopisBasketOrderSummary from 'components/RopisBasketOrderSummary/RopisBasketOrderSummary';
import withGlobalModals from 'hocs/withGlobalModals';

const ConnectedRopisBasketOrderSummary = withGlobalModals(RopisBasketOrderSummary);

export default ConnectedRopisBasketOrderSummary;
